import React from "react";
import Globe from "react-globe.gl";

const GlobeComponent = () => {
  return (
    <Globe
      width={900}
      height={900}
      cameraAltitude={1.2}
      backgroundColor="rgba(0,0,0,0)"
      globeImageUrl="//unpkg.com/three-globe/example/img/earth-night.jpg"
      bumpImageUrl="//unpkg.com/three-globe/example/img/earth-topology.png"
    />
  );
};

export default GlobeComponent;